// extracted by mini-css-extract-plugin
module.exports = {"container":"Version-container-2e9cba84c105d54ea41f90bd1ad78eec"};